/* eslint-disable no-console */
import React, { useContext, useEffect, useRef } from 'react';
import { BsFolder2Open } from 'react-icons/bs';
import { LanguageContext } from '../../../../../libs/Context';
import { IntersectionObserverFunction } from '../../../../../libs/CustomHooks/IntersectionObserver';

const Card = (props:any) =>
{
	const { item, index, selected, setSelected, LoadMore, filterData } = props;
	const { language } = useContext(LanguageContext);
	const lastElementRef = useRef(null);

	useEffect(() =>
	{
		return IntersectionObserverFunction(lastElementRef, LoadMore);
	}, [ lastElementRef?.current ]);

	return (
		<button tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && setSelected(item); }} className={`${selected?.folderId === item?.folderId ? 'selectMediaBg' : ''} flexRow pdngVXS alignCntr pointer`} onClick={() => setSelected(item)}>
			<div className='flexAutoRow'>
				<div className='flexInline alignCntr justifyCntr imgAvatarSM brdrBlackSM brdrRadiusSM'>
					<BsFolder2Open className='lightTxt' fontSize='26px' />
				</div>
			</div>
			<div className='flexMinWidthCol pdngHMD'>
				<span className='pointer PrimaryHoverTxt ellipsisTxt'>{item?.name}</span>
				<span className='lightTxt wordBreakAll'>{language.uploadedBy} {item?.uploadedBy ? item?.uploadedBy : item?.updatedBy?.name}</span>
			</div>
			{(index === filterData?.length - 1) && <span ref={lastElementRef} />}
		</button>
	);
};

export default Card;